"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/core/styles");
var _theme = _interopRequireDefault(require("../../theme"));
const useStyles = (0, _styles.makeStyles)({
  root: {
    backgroundColor: 'transparent',
    '& .menuList': {
      paddingLeft: '40px',
      paddingRight: '20px',
      fontFamily: _theme.default.typography.proxima.regular
    },
    '& .Mui-selected': {
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)'
      },
      '& .menuList': {
        paddingLeft: '12px',
        color: _theme.default.palette.primary.light
      },
      '& svg': {
        color: _theme.default.palette.primary.light,
        marginLeft: '20px'
      }
    },
    '& .MuiMenu-list': {
      padding: '0',
      paddingLeft: '0',
      '& .MuiListItem-root': {
        height: '50px',
        padding: '0',
        '&:not(.Mui-selected)': {
          '& .menuList': {
            marginLeft: '16px'
          }
        }
      }
    },
    '& .MuiPaper-root': {
      minWidth: '260px',
      boxShadow: '0px 2px 8px 2px rgb(6 21 86 / 40%) !important'
    }
  },
  label: {
    fontSize: _theme.default.typography.pxToRem(16),
    marginTop: _theme.default.typography.pxToRem(2)
  }
});
var _default = exports.default = useStyles;